import { Button, Card, Heading, Text } from '../../styledComponents';
import styles from './MessageCard.module.css';

type MessageCardProps = {
  emoji?: string;
  heading: string | undefined;
  message: string | undefined;
  buttonText: string;
  width?: number;
  onClick: () => void;
  buttonColor?: string | undefined;
  buttonTextColor?: string | undefined;
  titleColor?: string | undefined;
  textColor?: string | undefined;
  fontStyle?: string | undefined;
};

export default function MessageCard({
  emoji,
  heading,
  message,
  buttonText,
  onClick,
  width,
  buttonTextColor,
  buttonColor,
  titleColor,
  textColor,
  fontStyle,
}: MessageCardProps) {
  return (
    <Card width={width ? `${width}px` : '336px'}>
      <div className={styles.emojiContainer}>
        <p>{emoji || '🙌'}</p>
      </div>
      <div className={styles.textContainer}>
        <Heading fontFamily={fontStyle} as="h2" fontSize="20px" textAlign="center" color={titleColor || '#2f2f2f'}>
          {heading}
        </Heading>
        <Text fontFamily={fontStyle} textAlign="center" fontSize="14px" color={textColor || '#667085'}>
          {message}
        </Text>
      </div>
      <Button
        onClick={onClick}
        width="100%"
        bgColor={buttonColor || '#7F56D9'}
        color={buttonTextColor || '#fff'}
        fontSize="14px"
      >
        {buttonText}
      </Button>
    </Card>
  );
}
